var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobdive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49057 6.19579C7.54523 5.89999 7.80065 5.68555 8.09834 5.68555C8.39603 5.68555 8.65145 5.89999 8.70611 6.19579L9.35592 9.66954C9.45037 10.175 9.84146 10.5703 10.3415 10.6658L13.7779 11.3227C14.0705 11.3779 14.2826 11.6361 14.2826 11.937C14.2826 12.238 14.0705 12.4962 13.7779 12.5514L10.3415 13.2083C9.84146 13.3038 9.45037 13.6991 9.35592 14.2045L8.70611 17.6783C8.65145 17.9741 8.39603 18.1885 8.09834 18.1885C7.80065 18.1885 7.54523 17.9741 7.49057 17.6783L6.84076 14.2045C6.74631 13.6991 6.35521 13.3038 5.85522 13.2083L2.41882 12.5514C2.1262 12.4962 1.91406 12.238 1.91406 11.937C1.91406 11.6361 2.1262 11.3779 2.41882 11.3227L5.85522 10.6658C6.35521 10.5703 6.74631 10.175 6.84076 9.66954L7.49057 6.19579Z",
    stroke: "#4B1498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0106 14.2449C17.0401 14.1029 17.178 14 17.3387 14C17.4994 14 17.6373 14.1029 17.6668 14.2449L18.0176 15.9119C18.0686 16.1544 18.2798 16.3441 18.5497 16.3899L20.4049 16.7052C20.5629 16.7317 20.6774 16.8556 20.6774 17C20.6774 17.1444 20.5629 17.2683 20.4049 17.2948L18.5497 17.6101C18.2798 17.6559 18.0686 17.8456 18.0176 18.0881L17.6668 19.7551C17.6373 19.8971 17.4994 20 17.3387 20C17.178 20 17.0401 19.8971 17.0106 19.7551L16.6598 18.0881C16.6088 17.8456 16.3976 17.6559 16.1277 17.6101L14.2725 17.2948C14.1145 17.2683 14 17.1444 14 17C14 16.8556 14.1145 16.7317 14.2725 16.7052L16.1277 16.3899C16.3976 16.3441 16.6088 16.1544 16.6598 15.9119L17.0106 14.2449Z",
    stroke: "#4B1498",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22583 19.6667C2.22583 20.5865 2.97264 21.3333 3.8925 21.3333C4.81236 21.3333 5.55916 20.5865 5.55916 19.6667C5.55916 18.7468 4.81236 18 3.8925 18C2.97264 18 2.22583 18.7468 2.22583 19.6667V19.6667",
    stroke: "#4B1498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobdive);
export default __webpack_public_path__ + "static/media/jobdive.b9db8b1595b71b4d6bec0ef1a4d134f2.svg";
export { ForwardRef as ReactComponent };